import { RouteObject } from 'react-router';
import lazyImport from '~/utils/lazyImport';

const ChatIndexPage = lazyImport(() => import('~/views/chat/ChatIndexPage'));
const ChatNewPage = lazyImport(() => import('~/views/chat/ChatNewPage'));
const ChatLayout = lazyImport(() => import('~/views/chat/ChatLayout'));
const ChatTermsPage = lazyImport(() => import('~/views/chat/ChatTermsPage'));
const ChatConversation = lazyImport(() => import('~/views/chat/components/ChatConversation'));

export const chatRoutes: RouteObject[] = [
  {
    path: 'terms',
    element: <ChatTermsPage />,
  },
  {
    element: <ChatLayout />,
    children: [
      {
        index: true,
        element: <ChatIndexPage />,
      },
      {
        path: 'new',
        element: <ChatNewPage />,
      },
      {
        path: ':chatId',
        element: <ChatConversation />,
      },
    ],
  },
];
